<template>
    <div>
      <!-- Chip group for selecting outlook -->
      <div class="chip-group">
        <div
          v-for="outlook in outlooks"
          :key="outlook"
          :class="['chip', { active: selectedOutlook === outlook }]"
          @click="selectedOutlook = outlook"
        >
          {{ outlook }}
        </div>
      </div>
  
      <!-- Chip group for selecting price expectation -->
      <div class="chip-group">
        <div
          v-for="priceExpectation in priceExpectations"
          :key="priceExpectation"
          :class="['chip', { active: selectedPriceExpectation === priceExpectation }]"
          @click="selectedPriceExpectation = priceExpectation"
        >
          {{ priceExpectation }}
        </div>
      </div>
  
      <!-- Display the filtered strategies -->
      <div
        v-for="strategy in filteredStrategies"
        :key="strategy.option_strategy"
      >
        {{ strategy.option_strategy }}
        <!-- ... display other strategy details ... -->
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, computed } from 'vue';
  
  export default {
    name: 'OptionStrategySelector',
    setup() {
      const strategies = ref([]);
      const selectedOutlook = ref(null);
      const selectedPriceExpectation = ref(null);
  
      onMounted(async () => {
        const response = await fetch('https://farahk.pythonanywhere.com/api/option_strategies/');
        strategies.value = await response.json();
      });
  
      const filteredStrategies = computed(() => {
        return strategies.value.filter(strategy => {
          return (!selectedOutlook.value || strategy.outlook === selectedOutlook.value)
            && (!selectedPriceExpectation.value || strategy.price_expectation === selectedPriceExpectation.value);
        });
      });
  
      const outlooks = computed(() => {
        const outlookSet = new Set(strategies.value.map(strategy => strategy.outlook));
        return Array.from(outlookSet);
      });
  
      const priceExpectations = computed(() => {
        const priceExpectationSet = new Set(strategies.value.map(strategy => strategy.price_expectation));
        return Array.from(priceExpectationSet);
      });
  
      return {
        strategies,
        selectedOutlook,
        selectedPriceExpectation,
        filteredStrategies,
        outlooks,
        priceExpectations
      };
    }
  };
  </script>
  
  <style scoped>
  .chip-group {
    display: flex;
    flex-wrap: wrap;
  }
  
  .chip {
    padding: 10px;
    margin: 5px;
    border: 1px solid #ccc;
    border-radius: 16px;
    cursor: pointer;
  }
  
  .chip.active {
    background-color: #008CBA;
    color: white;
  }
  </style>
  